export default __webpack_public_path__ + "static/media/sbs-logo-submit.6ba63ed2.png";